const selectReasons = (state) => state.reasons;
export const selectReasonsData = (state) => selectReasons(state).data;
export const selectReasonsTotal = (state) => selectReasons(state).total;
export const selectReason = (state) => state.reason;
export const selectReasonsResources = (state) => state.resources;
export const selectReasonsByResource = (state) => state.reasonsByResource;
